<app-dialog-header [title]="(view === 'form' ? 'New bank request' : 'My Bank Requests')|translate" (closed)="close()"></app-dialog-header>
<div class="modal-body">
    @if (view === 'list') {
        <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="m-0">{{ 'My Bank Requests'|translate }}</h6>
            <app-button size="sm" (click)="showForm()">
                <i class="fa-solid fa-plus me-1"></i>{{ 'Add new bank request'|translate }}
            </app-button>
        </div>

        @if (requestsLoading) {
            <div class="d-flex align-items-center justify-content-center py-4">
                <mat-spinner diameter="28" color="primary"></mat-spinner>
            </div>
        } @else if (!requests.length) {
            <div class="d-flex align-items-center justify-content-center text-center text-secondary py-4">
                {{ 'No bank requests yet'|translate }}
            </div>
        } @else {
            <div class="list-group">
                @for (item of requests; track item.id) {
                    <div class="list-group-item d-flex flex-column gap-1">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                            <div class="d-flex align-items-center gap-2 mw-0">
                                <span class="fw-semibold text-ellipsis">{{ item.bankName }}</span>
                                <span class="text-secondary text-ellipsis">{{ item.clientName }}</span>
                            </div>
                            <app-bank-request-status-badge [status]="item.status"></app-bank-request-status-badge>
                        </div>
                        @if (item.statusNote) {
                            <div class="small text-secondary">{{ item.statusNote }}</div>
                        }
                        <div class="d-flex align-items-center gap-2 f-size-08em text-secondary">
                            <span>{{ 'Submitted'|translate }} {{ item.submittedAt|lsDate: 'MM/dd/yyyy' }}</span>
                            @if (item.eta) {
                                <span>&middot; {{ 'ETA'|translate }} {{ item.eta|lsDate: 'MM/dd/yyyy' }}</span>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    } @else {
    <form class="form-container border-0 p-0" [formGroup]="form" autocomplete="off" novalidate>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="your-name">
                            {{ 'Your name'|translate }}
                        </label>
                        <input type="text" class="form-control" id="your-name" name="current"
                               [ngClass]="{'invalid': form.controls['userFullName'].invalid && form.controls['userFullName'].touched}"
                               formControlName="userFullName">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['userFullName'].invalid && form.controls['userFullName'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="firm-name">
                            {{ 'Firm name'|translate }}
                        </label>
                        <input type="text" class="form-control" id="firm-name" name="current"
                               [ngClass]="{'invalid': form.controls['firmName'].invalid && form.controls['firmName'].touched}"
                               formControlName="firmName">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['firmName'].touched && form.controls['firmName'].hasError('required')">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="client-name">
                            {{ 'Client Name'|translate }}
                        </label>
                        <input type="text" class="form-control" id="client-name" name="current"
                               [ngClass]="{'invalid': form.controls['clientName'].invalid && form.controls['clientName'].touched}"
                               formControlName="clientName">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['clientName'].touched && form.controls['clientName'].hasError('required')">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="contact-phone-number">
                            {{ 'Contact phone number'|translate }}
                        </label>
                        <input type="phone" class="form-control" id="contact-phone-number" name="current"
                               [ngClass]="{'invalid': (form.controls['phoneNumber'].invalid)
                                 && form.controls['phoneNumber'].touched}"
                               formControlName="phoneNumber">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['phoneNumber'].hasError('required') && form.controls['phoneNumber'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="email">
                            {{ 'Email address'|translate }}
                        </label>
                        <input type="email" class="form-control" id="email" name="current"
                               [ngClass]="{'invalid': form.controls['email'].invalid && form.controls['email'].touched}"
                               formControlName="email">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['email'].invalid && form.controls['email'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="bank-name">
                            {{ 'Bank Name'|translate }}
                        </label>
                        <input type="text" class="form-control" id="bank-name" name="current"
                               [ngClass]="{'invalid': form.controls['bankName'].invalid && form.controls['bankName'].touched}"
                               formControlName="bankName">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['bankName'].invalid && form.controls['bankName'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="bank-url">
                            {{ 'Bank URL'|translate }}
                        </label>
                        <input type="text" class="form-control" id="bank-url" name="current"
                               [ngClass]="{'invalid': form.controls['bankUrl'].invalid && form.controls['bankUrl'].touched}"
                               formControlName="bankUrl">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['bankUrl'].invalid && form.controls['bankUrl'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="bank-login-url">
                            {{ 'Bank login URL (the login URL you use to login)'|translate }}
                        </label>
                        <input type="text" class="form-control" id="bank-login-url" name="current"
                               [ngClass]="{'invalid': form.controls['bankLoginUrl'].invalid && form.controls['bankLoginUrl'].touched}"
                               formControlName="bankLoginUrl">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['bankLoginUrl'].invalid && form.controls['bankLoginUrl'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="username">
                            Bank Login Username
                        </label>
                        <input type="text" class="form-control" id="username" name="current"
                               [ngClass]="{'invalid': form.controls['username'].invalid && form.controls['username'].touched}"
                               formControlName="username">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['username'].invalid && form.controls['username'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="password">
                            Bank Login Password
                        </label>
                        <input type="password" class="form-control" id="password" name="current"
                               [ngClass]="{'invalid': form.controls['password'].invalid && form.controls['password'].touched}"
                               formControlName="password">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['password'].invalid && form.controls['password'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="form-group">
                    <div class="mb-2">
                        <label for="notes">
                            {{ 'Notes - Security questions'|translate }}
                        </label>
                        <input type="text" class="form-control" id="notes" name="current"
                               [ngClass]="{'invalid': form.controls['notes'].invalid && form.controls['notes'].touched}"
                               formControlName="notes">
                    </div>
                    <div class="error-block"
                         *ngIf="form.controls['notes'].invalid && form.controls['notes'].touched">
                        {{ 'Please fill out this field'|translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-12 d-flex flex-column">
                What data should be collected?
                <div class="d-flex gap-3">
                    <mat-checkbox formControlName="extractChecks">Checks</mat-checkbox>
                    <mat-checkbox formControlName="extractStatements">Statements</mat-checkbox>
                    <mat-checkbox formControlName="extractTransactions">Transactions</mat-checkbox>
                </div>
            </div>
        </div>
    </form>
    }
</div>
<div class="modal-footer">
    @if (view === 'form') {
        <app-button variant="secondary" [outline]="true" (click)="showList()">{{ 'Back'|translate }}</app-button>
        <app-button (click)="onConfirmNewBankRequest()" [disabled]="form.invalid || loading"
                    [loading]="loading">{{ 'Send'|translate }}
        </app-button>
    }
</div>